import { render, staticRenderFns } from "./Head-Frame.vue?vue&type=template&id=5f17ce66&scoped=true&"
import script from "./Head-Frame.vue?vue&type=script&lang=js&"
export * from "./Head-Frame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f17ce66",
  null
  
)

export default component.exports